var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c("v-card-text", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column align-center justify-center text-center py-3",
              },
              [
                _c("h2", { staticClass: "mb-5" }, [
                  _vm._v("Registro de Cliente y Autorización de Datos"),
                ]),
                _c("p", { staticStyle: { "font-size": "large !important" } }, [
                  _vm._v(
                    "Personalice el formulario de registro de clientes y defina su política de Habeas Data"
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "mt-3",
          staticStyle: { "margin-left": "1% !important" },
          attrs: { justify: "center" },
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "overflow-visible",
              staticStyle: { height: "56px" },
            },
            [
              _c(
                "v-bottom-navigation",
                {
                  attrs: {
                    elevation: 24,
                    color: "rgb(204 33 40)",
                    width: "98% !important",
                  },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                [
                  _c(
                    "v-btn",
                    { staticClass: "nav-btn", attrs: { value: "config" } },
                    [_vm._v(" 1. Configuración de Formulario ")]
                  ),
                  _c(
                    "v-btn",
                    { staticClass: "nav-btn", attrs: { value: "inputConfig" } },
                    [_vm._v(" 2. Configuración de Campos ")]
                  ),
                  _c(
                    "v-btn",
                    { staticClass: "nav-btn", attrs: { value: "configEmail" } },
                    [_vm._v(" 3. Configuración plantilla correo ")]
                  ),
                  _c(
                    "v-btn",
                    { staticClass: "nav-btn", attrs: { value: "publication" } },
                    [_vm._v(" 4. Publicación y QR ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "base-card",
        [
          _c("v-card-text", { staticClass: "mt-3" }, [
            _c(
              "div",
              { staticClass: "py-6" },
              [_c(_vm.currentComponent, { tag: "component" })],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }